<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
        <div>
            <Link href="/">
                <h2 class="text-gray-600 font-bold text-3xl">Upload Level</h2>
            </Link>
        </div>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <Head title="Submit Level"/>

            <BreezeValidationErrors class="mb-4"/>

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>

            <form @submit.prevent="submit">
                <!--<div>
                    <BreezeLabel for="title" value="Title"/>
                    <BreezeInput id="title" type="text" class="mt-1 block w-full" v-model="form.title"
                                 autofocus
                                 autocomplete="string" required/>
                </div>-->

                <div>Level title will be taken from the level string</div>

                <div class="mt-4">
                    <BreezeLabel for="description" value="Description"/>
                    <BreezeInput id="description" type="text" class="mt-1 block w-full" v-model="form.description"
                                 required
                                 autocomplete="description"/>
                </div>

                <div class="mt-4">
                    <BreezeLabel for="string" value="Level String"/>
                    <BreezeInput id="string" type="text" class="mt-1 block w-full" v-model="form.string" required
                                 autocomplete="string"/>
                </div>

                <div class="flex items-center justify-end mt-4">
                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Submit
                    </BreezeButton>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import BreezeButton from '@/Components/Button.vue'
import BreezeCheckbox from '@/Components/Checkbox.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Input.vue'
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import {Head, Link} from '@inertiajs/inertia-vue3';

export default {
    components: {
        BreezeButton,
        BreezeCheckbox,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
        Head,
        Link,
        BreezeGuestLayout,
    },

    props: {
        errors: Object,
        auth: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                title: '',
                description: '',
                string: '',
            })
        }
    },

    methods: {
        submit() {
            let array;
            try {
                array = JSON.parse(this.form.string)
            } catch (e) {
                alert("Invalid level string!")
                return;
            }
            this.form.title = array[2][0][1]

            this.form.post(this.route('tig::levels.store'), {
                onFinish: () => this.form.reset(),
            })
        }
    }
}
</script>
